/**
 * Development environment. Firebase project: dev-koomzoapps (from koomzoinfra).
 * apiKey and appId should match Terraform firebase_config output or GitLab CI variables.
 */
export const environment = {
  production: false,
  saasAppUrl: 'https://app.dev.koomzo.com',
  electronReleasesManifestUrl: 'https://storage.googleapis.com/dev-koomzoapps-electron-downloads/releases/electron/manifest.json',
  firebase: {
    apiKey: 'YOUR_DEV_FIREBASE_API_KEY',
    authDomain: 'dev-koomzoapps.firebaseapp.com',
    projectId: 'dev-koomzoapps',
    storageBucket: 'dev-koomzoapps.appspot.com',
    messagingSenderId: 'YOUR_DEV_MESSAGING_SENDER_ID',
    appId: 'YOUR_DEV_APP_ID'
  }
};
